import { render, staticRenderFns } from "./custosFixos.vue?vue&type=template&id=58a5be8d&scoped=true&"
import script from "./custosFixos.vue?vue&type=script&lang=js&"
export * from "./custosFixos.vue?vue&type=script&lang=js&"
import style0 from "./custosFixos.vue?vue&type=style&index=0&id=58a5be8d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a5be8d",
  null
  
)

export default component.exports